export const issueVisibility = {
    PUBLIC: { value: 0, label: 'Public' },
    PRIVATE: { value: 1, label: 'Private' },
    RESTRICTED: { value: 2, label: 'Restricted' }
}